import axios from 'axios'
import qs from 'qs'

const state = () => ({
  loaded: false,
  products: [],
  currentPage: 1,
  itemsPerPage: 12, // 12
  numberOfPages: 1,
  numberOfTotalItems: 0
})

const getters = {
  getParams: (state, getters, rootState) => {
    const params = {
      currentPage: state.currentPage,
      itemsPerPage: state.itemsPerPage,
      hiddenInList: {
        equals: 0
      }
    }
    if ((rootState.filter.filterCategories && rootState.filter.filterCategories.length) || rootState.filter.selectedCategoryId > 0) {
      // eslint-disable-next-line prefer-const
      let filterCatIds = ''
      if (rootState.filter.selectedCategoryId > 0) {
        filterCatIds += rootState.filter.selectedCategoryId
      }
      if (rootState.filter.selectedCategoryId > 0 && rootState.filter.filterCategories.length > 0) {
        filterCatIds += ';'
      }

      if (rootState.filter.filterCategories.length > 0) {
        // or-filter between sub categories ','
        // and filter between level 1 categories  ';'
        const filterArray = rootState.filter.filterCategories.sort((a, b) => {
          return a.parent - b.parent
        })
        let lastParent = filterArray[0].parent
        for (let i = 0; i < filterArray.length; i++) {
          if (i > 0) {
            if (filterArray[i].parent === lastParent) {
              filterCatIds += ','
            } else {
              filterCatIds += ';'
            }
          }
          filterCatIds += filterArray[i].categoryId
          lastParent = filterArray[i].parent
        }
      }
      params.variants_categories = {
        contains: filterCatIds
      }
    }
    if (rootState.filter.sortingAsc) {
      params.order = {
        title: 'ASC'
      }
    }
    if (rootState.filter.sortingDsc) {
      params.order = {
        title: 'DESC'
      }
    }
    return params
  }
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setProducts (state, payload) {
    state.products = payload
  },
  addProducts (state, payload) {
    state.products = [...state.products, ...payload]
  },
  resetCurrentPage (state) {
    state.currentPage = 1
    state.products = []
  },
  setCurrentPage (state, payload) {
    state.currentPage = payload
    state.products = []
  },
  increaseCurrentPage (state) {
    if (state.currentPage < state.numberOfPages) {
      state.currentPage += 1
    }
  },
  decreaseCurrentPage (state) {
    if (state.currentPage > 1) {
      state.currentPage -= 1
    }
  },
  setNumberOfPages (state, payload) {
    state.numberOfPages = payload
  },
  setNumberOfTotalItems (state, payload) {
    state.numberOfTotalItems = payload
  }
}

const actions = {
  async get ({ commit, getters }) {
    commit('setLoaded', false)
    try {
      const response = await axios.get(window.app.product_list.api_base + 'products-products' + '/?' + qs.stringify(getters.getParams))
      commit('setProducts', response.data.products)
      commit('setNumberOfPages', response.data.numberOfPages)
      commit('setNumberOfTotalItems', response.data.numberOfTotalItems)
      commit('setLoaded', true)
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  },
  async increasePage ({ commit }) {
    commit('increaseCurrentPage')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
